// The no-reviewer support card's reviewer-found note: the hmrc/trust-score-review cron writes it on the card's job (metadata
// REVIEWER_FOUND, a JSON object with personId and at) once someone at the company has the HMRC review card again, and nulls it
// when nobody can review again. Pure, so the unit tests import it.
import { formatDate } from '../../../../helpers/format.js';

export const REVIEWER_FOUND_KEY = 'REVIEWER_FOUND';

export interface ReviewerFound {
  personId: string;
  // When the review card went to them (ISO)
  at: string;
}

type Metadata = ReadonlyArray<{ key?: string | null; value?: string | null } | null | undefined> | null | undefined;

const filled = (value: unknown): value is string => typeof value === 'string' && value.trim() !== '';

// The note, or null when the job has none, the cron cleared it, or it cannot be read
export function reviewerFound(metadata: Metadata): ReviewerFound | null {
  const value = (metadata ?? []).find((m) => m?.key === REVIEWER_FOUND_KEY)?.value;
  if (!filled(value)) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    return null;
  }
  if (typeof parsed !== 'object' || parsed === null) return null;
  const { personId, at } = parsed as Record<string, unknown>;
  if (!filled(personId) || !filled(at) || Number.isNaN(new Date(at).getTime())) return null;
  return { personId, at };
}

// What the card says once someone can review: the person's name when support could read it, else "Someone"
export function reviewerFoundMessage(companyName: string, note: ReviewerFound, personName?: string | null): string {
  const who = filled(personName) ? personName.trim() : 'Someone';
  return `${who} at ${companyName} can review again: the review card went to them on ${formatDate(note.at, 'longDate')}. Mark this resolved once you've checked.`;
}
